"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InboxIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.26 2.606A1 1 0 0011.34 2H4.66a1 1 0 00-.92.606L1 9v4a1 1 0 001 1h12a1 1 0 001-1V9l-2.74-6.394zm.466 4.708A.5.5 0 0112.26 8H9.732a2 2 0 11-3.465 0H3.74a.5.5 0 01-.465-.686l1.6-4A.5.5 0 015.34 3h5.322a.5.5 0 01.465.314l1.6 4z",
    clipRule: "evenodd"
  })))
});
InboxIcon.displayName = 'InboxIcon';
var _default = exports.default = InboxIcon;